document.addEventListener('DOMContentLoaded', () => {
  const formatSentenceCase = (str) => {
    const allLower = str.toLowerCase()
    return allLower.charAt(0).toUpperCase() + allLower.slice(1)
  }

  // nav links
  const navLinks = document.querySelectorAll('.account-nav li a:not([href="/a/account/shopify-login"]):not([href*="swym-wishlist"])')
    console.log('navLinks');
    console.log(navLinks);
  navLinks.forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault()
      const target = link.dataset.accountTabTarget
      navLinks.forEach((link) => { link.parentElement.classList.remove('selected') })
      const accountSections = document.querySelectorAll('.account-section')
      accountSections.forEach((section) => { section.classList.remove('selected') })
      link.parentElement.classList.add('selected')
      const selectedSections = document.querySelectorAll('.account-section[data-account-tab="' + target + '"]')
      selectedSections.forEach((section) => { section.classList.add('selected') })
      const pageTitle = document.querySelector('.customer-hero .title')
      pageTitle.innerText = formatSentenceCase(link.innerText)
      const accountContainer = document.querySelector('.account-container')
      if (target === 'rewards') {
        accountContainer && accountContainer.classList.add('no-sidebar')
      } else if (accountContainer.classList.contains('no-sidebar')) {
        accountContainer && accountContainer.classList.remove('no-sidebar')
      }
      return false
    })
  })

  // form edit buttons
  const editButtons = document.querySelectorAll('.account-settings-group .edit-link')
  editButtons.forEach((button) => {
    button.addEventListener('click', (e) => {
      e.preventDefault()
      let nearestGroup = button.closest('.account-settings-group-input')
      if (!nearestGroup) {
        nearestGroup = button.closest('.account-settings-group')
      }
      if (nearestGroup.classList.contains('mid-edit')) {
        nearestGroup.classList.remove('mid-edit')
        button.innerText = 'EDIT'
      } else {
        nearestGroup.classList.add('mid-edit')
        button.innerText = 'CANCEL'
      }
      return false
    })
  })

  // form inputs
  const saveButtons = document.querySelectorAll('.account-settings-group .save-button')
  saveButtons.forEach((button) => {
    button.addEventListener('click', (e) => {
      e.preventDefault()
      let nearestGroup = button.closest('.account-settings-group-input')
      if (!nearestGroup) {
        nearestGroup = button.closest('.account-settings-group')
      }
      if (!nearestGroup) {
        return false
      }
      const targetEndpoint = nearestGroup.dataset.accountSettingsEndpoint
      if (!targetEndpoint) {
        console.log('bailing because no endpoint for button', nearestGroup)
        return false
      }
      const inputForms = nearestGroup.querySelectorAll('input')
      const payloadUpdates = {
        id: window.account_customer_id
      }
      for (let i = 0; i < inputForms.length; i++) {
        const input = inputForms[i]
        const inputName = input.name
        const inputValue = input.value
        payloadUpdates[inputName] = inputValue
      }
      button.innerText = 'SAVING CHANGES'
      const currentErrorFields = nearestGroup.querySelectorAll('.form-error')
      currentErrorFields.forEach((errorField) => {
        errorField.remove()
      })
      fetch('https://asqecxs6u1.execute-api.us-west-2.amazonaws.com/dev/accounts/' + targetEndpoint, {
        method: 'POST',
        body: JSON.stringify(payloadUpdates),
        headers: {
          'Content-Type': 'application/json',
          'X-Credo-Account-Access-Key': window.account_update_token
        }
      }).then(async (response) => {
        const data = await response.json();
        if (!response.ok) {
          button.innerText = 'SAVE CHANGES'
          const formInputWrappers = button.closest('.edit').querySelectorAll('.input-wrapper')
          const lastInputWrapper = formInputWrappers[formInputWrappers.length - 1]
          const errorMessageEl = document.createElement('div')
          errorMessageEl.classList.add('warning-message')
          errorMessageEl.classList.add('form-error')
          errorMessageEl.innerText = data.error || 'Unknown error'
          lastInputWrapper.insertAdjacentElement('afterend', errorMessageEl)
        }
        return data
      }).then((data) => {
        if (data.status === 'OK') {
          // #TODO: Update values inline if possible?
          window.location.reload()
        }
      }).catch((error) => {
        console.error(error)
        button.innerText = 'SAVE CHANGES'
      })
      return false
    })
  })

  // Also check nav links on page load
  const accountSections = document.querySelectorAll('.account-section')
  const pageHash = window.location.hash
  if (pageHash) {
    let target = pageHash.replace('#', '')
    let link = document.querySelector('.account-nav li a[data-account-tab-target="' + target + '"]')
    if (link) {
      navLinks.forEach((link) => { link.parentElement.classList.remove('selected') })
      link.parentElement.classList.add('selected')
      const selectedSections = document.querySelectorAll('.account-section[data-account-tab="' + target + '"]')
      if (selectedSections.length > 0) {
        accountSections.forEach((section) => { section.classList.remove('selected') })
        selectedSections.forEach((section) => { section.classList.add('selected') })
        const pageTitle = document.querySelector('.customer-hero .title')
        pageTitle.innerText = formatSentenceCase(link.innerText)
      }
      const accountContainer = document.querySelector('.account-container')
      if (target === 'rewards') {
        accountContainer && accountContainer.classList.add('no-sidebar')
      } else if (accountContainer.classList.contains('no-sidebar')) {
        accountContainer && accountContainer.classList.remove('no-sidebar')
      }
    }
  }

})

const showBody = document.querySelector('.show-body')
if (showBody) showBody.style.display = 'none'

// Rewards event listener
function formatMoney(price, currency = 'USD') {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency }).format(price).replace('.00', '')
}
const messages = [
  'Trying to call your points but they haven’t answered yet.',
  'Free products are worth the wait.',
  'Patience is a virtue. But also this is taking a while.',
  'While we wait, have I told you you look stunning today?',
  'Haiku: This loading slow. Credo\'s rewards are worth it. Please wait a minute.',
  'The best gifts in life are worth a little patience.',
  'Patience is golden, but these points are testing me!',
  'As we eagerly wait, did you notice how the time seems to slow?',
  'Haiku: Points accumulating. Anticipation grows. Patience is rewarded.',
  'Waiting for points, like waiting for a call back from a crush.',
  'Good things come to those who wait… and wait… and wait.',
  'The anticipation builds, as does your point balance.',
  'Ever tried holding your breath while waiting? Just kidding, don’t!',
  'It’s not the wait that’s long; it’s the anticipation that’s killing me!',
  'While points are on their way, let’s admire the journey.',
  'Haiku: Loading takes its time. But rewards are on their way. Breathe in, breathe out, wait.',
  'A watched account never accrues – look away for a surprise!',
  'Remember, the longer the wait, the sweeter the reward.',
  'The clock ticks slowly, but the points will surely come.',
  'Patience, my friend, the points are just around the corner.',
  'Every tick of the clock brings us closer to the prize.',
  'They say good things take time; these points are no exception.',
  'The longer the wait, the greater the excitement.',
  'In this game of patience, the points are the ultimate prize.',
  'As we wait, let’s imagine the joy of spending those points.'
]
const waitingMessageElement = document.querySelector('.waiting-message')
let currentIndex = -1
function updateMessage() {
  let newIndex
  do {
    newIndex = Math.floor(Math.random() * messages.length)
  } while (newIndex === currentIndex)
  currentIndex = newIndex
  if (waitingMessageElement) {
    waitingMessageElement.textContent = messages[currentIndex]
  }
}
updateMessage()
const intervalCNId = setInterval(updateMessage, 10000)

// Rewards event listener
document.addEventListener('swell:setup', function() {
  const customerDetails = swellAPI.getCustomerDetails()
  console.log('Swell customer details: ', customerDetails)
  if (!customerDetails || !customerDetails.vipTier) {
    return false
  }
  const rewardsSummaries = document.querySelectorAll('.rewards-summary')
  const vipTier = customerDetails.vipTier
  const cusPoints = customerDetails.pointsBalance
  const cusTierIndex = Number(vipTier.name.split(' ')[1])
  const tierNameMap = { 1: 'bronze', 2: 'silver', 3: 'gold' }
  const cusTierName = tierNameMap[cusTierIndex] || 'bronze'
  const nextTierNameMap = { 1: 'Silver', 2: 'Gold', 3: null }
  const nextTierName = nextTierNameMap[cusTierIndex]
  const cusSpendToNextTier = customerDetails.vipTierStatsNeeded ? customerDetails.vipTierStatsNeeded.amountSpentCents : null
  rewardsSummaries.forEach((summary) => {
    const tierLevelLabel = summary.querySelector('.tier-level')
    if (tierLevelLabel) {
      tierLevelLabel.innerText = cusTierName
      tierLevelLabel.classList.remove('tier-1')
      tierLevelLabel.classList.remove('tier-2')
      tierLevelLabel.classList.remove('tier-3')
      tierLevelLabel.classList.remove('tier-bronze')
      tierLevelLabel.classList.remove('tier-silver')
      tierLevelLabel.classList.remove('tier-gold')
      tierLevelLabel.classList.add(`tier-${cusTierName}`)
    }

    const pointsLabels = summary.querySelectorAll('[data-rewards-badge-text]')

    pointsLabels.forEach((pointsLabel) => {
      pointsLabel.innerText = `${cusPoints} pts`
    })
  

    const togoLabel = summary.querySelector('.rewards-badge-to-go-text')
    if (togoLabel) {
      if (cusSpendToNextTier && nextTierName) {
        togoLabel.innerText = `Spend ${formatMoney(cusSpendToNextTier * 0.01)} to reach ${nextTierName} tier`
      } else {
        togoLabel.remove()
      }
    }
    if (cusPoints && togoLabel && tierLevelLabel) {
      document.querySelector('.loading-body').style.display = 'none'
      document.querySelector('.show-body').style.display = 'flex'
      clearInterval(intervalCNId)
    }
  })

  const myBenefits = document.querySelector('.account-settings-group.my-benefits')
  if (myBenefits) {
    const tierTitleText = myBenefits.querySelectorAll('.tier-number-text')
    tierTitleText.forEach((titleText) => {
      titleText.innerText = cusTierName
    })
    const viewAllButton = myBenefits.querySelector('.view-link')
    viewAllButton.addEventListener('click', (e) => {
      e.preventDefault()
      const benefitsList = document.querySelector('.account-settings-group.all-benefits')
      const benefitsRect = benefitsList.getBoundingClientRect()
      const stickyHeader = document.querySelector('sticky-header')
      const headerRect = stickyHeader.getBoundingClientRect()
      const scrollPosition = benefitsRect.top + window.scrollY - headerRect.bottom
      window.scrollTo({ top: scrollPosition, behavior: 'smooth' })
      return false
    })
    const benefitsList = myBenefits.querySelectorAll('.benefits-list')
    benefitsList.forEach((benefit) => {
      benefit.style.display = 'none'
    })
    const applicableBenefitList = myBenefits.querySelector(`.benefits-list.tier-${cusTierName}`)
    applicableBenefitList.style.display = 'flex'
  }
})

// Notification Settings
const accountSettingsTogglesArray = document.querySelectorAll('[data-account-settings-toggle-line]')
const closePopupButtons = document.querySelectorAll("[data-notifications-popup-close]")

// Close Notification Popup
closePopupButtons.forEach((closeBtn) => {
  closeBtn.addEventListener('click', (e) => {
    e.preventDefault()
    const openedPopup = document.querySelector('.notifications-popup.popup-active')
    openedPopup && openedPopup.classList.remove('popup-active')
  })
})
function requiredCheckApproved(notificationPopup, subject) {
  const input = notificationPopup.querySelector(`[data-notifications-popup-${subject}-phone-input`)
  if (input && input.hasAttribute('required') && input.value === '') {
    return false
  }
  return true
}
function termsCheckboxListeners(notificationPopup, subject) {
  const termsLabel = notificationPopup.querySelector('[data-notifications-terms-label]')
  const termsCheckbox = notificationPopup.querySelector('[data-notifications-terms-checkbox]')
  const submitButton = notificationPopup.querySelector(`[data-notifications-popup-${subject}-save-btn]`)
  const termsLabelLinks = notificationPopup.querySelectorAll('[data-notifications-terms-label] a')
  if (!termsLabel || !termsCheckbox || !submitButton) {
    console.log("Checkbox elements not found")
    return
  }

  termsLabel.addEventListener('click', (e) => {
    e.preventDefault()
    if (termsCheckbox.checked === false && requiredCheckApproved(notificationPopup, subject)) {
      termsCheckbox.checked = true
      submitButton.classList.remove('disabled')
      submitButton.removeAttribute('disabled')
    } else {
      termsCheckbox.checked = false
      submitButton.classList.add('disabled')
      submitButton.setAttribute('disabled', 'disabled')
    }
  })
  termsLabelLinks.forEach((link) => {
    link && link.addEventListener('click', (e) => { e.stopPropagation() })
  })
}
function toggleClicked(toggleLine) {
  const fieldInput = toggleLine.querySelector('[data-account-settings-toggle-input]')
  const fieldSubject = fieldInput.dataset.accountSettingsToggleInput
  const notificationPopup = document.querySelector(`[data-notifications-popup-${fieldSubject}]`)
  // Check/Uncheck
  if (fieldInput.hasAttribute('checked')) {
    notificationPopup && fieldInput.removeAttribute('checked')
  } else {
    notificationPopup && fieldInput.setAttribute('checked', 'checked')
  }
  // Open Popup
  if (notificationPopup) notificationPopup.classList.add('popup-active')
  termsCheckboxListeners(notificationPopup, fieldSubject)
}
function initAccountSettingsToggleLister () {
  accountSettingsTogglesArray.forEach((toggleLine) => {
    const toggleField = toggleLine.querySelector('[data-account-settings-toggle-label]')
    if (!toggleField) {
      console.log('No label toggle found')
      return
    }
    toggleField.addEventListener('click', (e) => {
      e.preventDefault()
      toggleClicked(toggleLine)
    })
  })
}
function onPageLoad() {
  if (accountSettingsTogglesArray) initAccountSettingsToggleLister()
}
document.addEventListener('DOMContentLoaded', onPageLoad)
// End - Notification Settings